<template>
    <div class="c-anzcor-search c-algolia-search__wrapper">
        <anzcor-search-filter></anzcor-search-filter>
        <anzcor-search-results></anzcor-search-results>
    </div>
</template>

<script>
import AnzcorSearchFilter from "./AnzcorSearchFilter.vue";
import AnzcorSearchResults from "./AnzcorSearchResults.vue";

export default {
    data() {
        return {};
    },
    components: {
        AnzcorSearchResults,
        AnzcorSearchFilter,
    },
    mounted() {},
    computed: {},
    methods: {},
};
</script>
<style lang="scss"></style>
